import cn from 'classnames';

import { IConDefaultType } from 'Icons';

export enum RoundLogoIconVariant {
  DEFAULT = 'default',
  DISABLE = 'disable',
}

export interface IRoundLogoIconProps extends IConDefaultType {
  variant?: RoundLogoIconVariant;
}

function RoundLogoIcon({
  color,
  className,
  size = 28,
  rotate,
  flip,
  variant = RoundLogoIconVariant.DEFAULT,
}: IRoundLogoIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === RoundLogoIconVariant.DEFAULT && (
        <svg width={size} height={size} viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="14" cy="14.5996" r="14" fill="#141111" />
          <path
            d="M13.6506 19.3599C12.4922 19.3632 11.8061 18.773 11.8061 17.59V13.6768H16.2428C16.5287 13.1314 16.7411 12.3524 16.7415 11.732C16.7422 10.5357 16.052 9.93792 14.6728 9.93792H11.8061V6.57292C11.2174 6.33347 10.5331 6.19175 9.88688 6.19952C8.71539 6.19197 7.79334 6.68776 7.79334 7.96877V9.93837H6.09828C5.81196 10.4879 5.59961 11.2431 5.59961 11.8822C5.59961 13.0786 6.28909 13.677 7.66828 13.677H7.79334V18.4623C7.79334 21.3932 9.89577 22.9983 12.7037 22.9992C14.1208 22.9986 16.2688 22.5028 17.3646 21.5283L15.7946 18.7868C15.2068 19.1511 14.3334 19.3632 13.6506 19.3599Z"
            fill="#FF5776"
          />
          <path
            d="M19.7295 6.19922C19.4512 7.79874 18.9991 8.52914 17.3652 8.84178V8.98094C18.9648 9.294 19.4166 9.98922 19.7295 11.6235H19.8686C20.147 10.0244 20.599 9.294 22.2333 8.98094V8.84178C20.6334 8.52914 20.1817 7.8335 19.8686 6.19922H19.7295Z"
            fill="#FCDB9F"
          />
        </svg>
      )}
      {variant === RoundLogoIconVariant.DISABLE && (
        <svg width={size} height={size} viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="14" cy="14.7998" r="14" fill="#201E1E" />
          <path
            d="M13.6511 19.5601C12.4927 19.5634 11.8066 18.9732 11.8066 17.7902V13.877H16.2433C16.5292 13.3316 16.7415 12.5526 16.742 11.9322C16.7427 10.7359 16.0525 10.1381 14.6733 10.1381H11.8066V6.77311C11.2179 6.53366 10.5335 6.39194 9.88737 6.39972C8.71587 6.39217 7.79382 6.88795 7.79382 8.16896V10.1386H6.09877C5.81245 10.6881 5.6001 11.4433 5.6001 12.0824C5.6001 13.2788 6.28958 13.8772 7.66877 13.8772H7.79382V18.6625C7.79382 21.5934 9.89626 23.1985 12.7042 23.1994C14.1213 23.1987 16.2693 22.703 17.3651 21.7285L15.7951 18.987C15.2073 19.3513 14.3339 19.5634 13.6511 19.5601Z"
            fill="white"
          />
          <path
            d="M19.7295 6.39941C19.4512 7.99894 18.9991 8.72933 17.3652 9.04198V9.18113C18.9648 9.4942 19.4166 10.1894 19.7295 11.8237H19.8686C20.147 10.2246 20.599 9.4942 22.2333 9.18113V9.04198C20.6334 8.72933 20.1817 8.03369 19.8686 6.39941H19.7295Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default RoundLogoIcon;
